import { useState, useCallback } from "react";

export const useConfirmation = () => {

    const [confirmation, setConfirmation] = useState({
        isOpen: false,
        options: {},
        refToResolveFunction: null,
    });

    const requestConfirmation = useCallback((options = {}) => {
        return new Promise((resolve) => {
            setConfirmation({ isOpen: true, options, refToResolveFunction: resolve });
        });
    }, []);

    const confirm = () => {
        if (confirmation.refToResolveFunction) confirmation.refToResolveFunction(true);
        setConfirmation({ isOpen: false, options: {}, refToResolveFunction: null });
    };

    const cancel = () => {
        if (confirmation.refToResolveFunction) confirmation.refToResolveFunction(false);
        setConfirmation({ isOpen: false, options: {}, refToResolveFunction: null });
    };

    return {
        requestConfirmation,
        confirmation,
        confirm,
        cancel,
    };
};
